import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import wooriSymbol from 'images/tmp_woori_symbol.png'
import styles from './index.module.css'

const CompanyDetail2 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(1)
	const [tabMenu, setTabMenu] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className="shadow">
					<div className="padding pt_40 pb_50">
						<div className={`${styles["company-title"]} align_start`}>
							<div className={styles["detail-title"]}>
								<span className={styles.tag}>#기업규모</span>
								<div className="mt_5">주식회사 모니</div>
								<span className={`${styles.number} mt_5`}>(1138653976)</span>

								{/* 폐업인 경우 태그 노출 */}
								<div className="mt_10">
									<i className="tag tag-box tag-red">폐업</i>
								</div>

								{/* 휴업인 경우 태그 노출 */}
								<div className="mt_10">
									<i className="tag tag-box tag-gray">휴업</i>
								</div>
							</div>

							<div className="img-box img-symbol img-symbol-lg">
								<img src={wooriSymbol} alt="" />
							</div>

							{/* 폐업인 경우 이미지 노출 */}
							{/* <div className={`${styles["company-stop"]} img-box img-symbol img-symbol-lg`}>
							<i className="icon icon_shut_down" />
						</div> */}
						</div>
					</div>
				</div>

				{/* 재무상태 */}
				<div className="shadow">
					<div className="padding pt_40">
						<ul className="tab-round">
							<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기업정보</li>
							<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>재무정보</li>
						</ul>
						<h3 className="mt_40">재무상태</h3>
						<div className={`${styles["l-title"]} mt_30`}>
							작년 대비<br /><strong>47.5% 상승</strong>했어요!
						</div>
						<div className={`${styles["financial-bar"]} mt_30 pt_30`}>
							<div>
								<div className={`${styles.bar} ${styles.min}`}>
									<span style={{ height: 0 }} />
								</div>
								<p>2017/12</p>
							</div>
							<div>
								<div className={styles.bar}>
									<span style={{ height: "35%" }} />
								</div>
								<p>2018/12</p>
							</div>
							<div>
								<div className={styles.bar}>
									<span style={{ height: "60%" }} />
								</div>
								<p>2019/12</p>
							</div>
							<div className={styles.point}>
								<div className={styles.bar}>
									<span style={{ height: "100%" }}>
										<span className={styles["result-txt"]}>18억 3,500만원</span>
									</span>
								</div>
								<p>2020/12</p>
							</div>
						</div>
						<div className={`${styles["property-area"]} mt_40`}>
							<span className={styles.arrow} style={{ left: "83%" }} />
							<ul className="tab-round-box mx_40">
								<li onClick={() => setTabMenu(0)} className={tabMenu === 0 ? "on" : ""}>자산</li>
								<li onClick={() => setTabMenu(1)} className={tabMenu === 1 ? "on" : ""}>부채/자본</li>
							</ul>
							<div className="text-align_center mt_30">
								<div className={styles["result-title"]}>2020년 자산</div>
								<div className={styles["company-price"]}>18억 3,500만원</div>
							</div>
							<ul className={`${styles["rate-percentage"]} mt_30`}>
								<li style={{ width: "35.81%" }}>
									<span>35.81%</span>
								</li>
								<li style={{ width: "64.19%", left: "35.81%" }}>
									<span>64.19%</span>
								</li>
							</ul>
							<ul className={`${styles["info-item"]} mt_30`}>
								<li>
									<div className="color-title">
										<p className="light-gray">유동자산</p>
									</div>
									<span>5억 5,300만원</span>
								</li>
								<li>
									<div className="color-title">
										<p className="light-blue">비유동자산</p>
									</div>
									<span>12억 8,200만원</span>
								</li>
							</ul>
						</div>
					</div>
				</div>

				{/* 경영실적 */}
				<div className="padding pt_40">
					<h3>경영실적</h3>

					{/* 그래프 영역 */}
					<div className="mt_40" style={{ height: "23.6rem", background: "#f5f5f5" }}></div>
					<div className={`${styles["property-area"]} mt_40`}>
						<span className={styles.arrow} style={{ left: "83%" }} />
						<ul className={`${styles["info-item"]}`}>
							<li>
								<div className="color-title">
									<p className="light-blue">당기순이익</p>
								</div>
								<span>4억 6,800만원</span>
							</li>
							<li>
								<div className="color-title">
									<p className="green">영업이익 증가율</p>
								</div>
								<span>21.68%</span>
							</li>
							<li>
								<div className="color-title">
									<p className="yellow">매출액 증가율</p>
								</div>
								<span>7.68%</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={styles["guide-bottom"]}>NICE평가정보에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default CompanyDetail2